// extracted by mini-css-extract-plugin
export default {"zoomModal":"N4-z"};